import { z } from 'zod';

/** Übertragung eines Produkts an den Marktplatz-Shop (Anzeige im Marktplatz-Konto) */
export interface ShopProduktUebertragung {
  /**
   * offen: wartet auf die Übertragung · laeuft: wird gerade übertragen · fehler: letzter Versuch fehlgeschlagen
   * (wird wiederholt bzw. nach 5 Versuchen aufgegeben) · ok: übertragen · null: noch nie übertragen
   */
  stand: 'offen' | 'laeuft' | 'fehler' | 'ok' | null;
  fehler: string;
  hinweis: string;
  versuche: number;
  naechsterVersuch: string | null;
  uebertragenAm: string | null;
}

export const SHOP_UEBERTRAGUNG_TITEL: Record<NonNullable<ShopProduktUebertragung['stand']>, string> = {
  offen: 'Wartet auf Übertragung',
  laeuft: 'Wird übertragen',
  fehler: 'Übertragung fehlgeschlagen',
  ok: 'Im Marktplatz-Shop',
};

/** Warteschlange des Marktplatzes (live_stand) */
export interface ShopUebertragungStand {
  offen: number;
  /** nach 5 Versuchen aufgegeben */
  fehler: number;
  zuletzt: string | null;
  kollektionenAm: string | null;
  letzterFehler: string;
  letzterFehlerAm: string | null;
}

export interface ShopUebertragungLauf {
  uebertragen: number;
  entfernt: number;
  uebersprungen: number;
  fehler: number;
  letzterFehler: string;
  kollektionen: number;
  versand: number;
  zeilen: string[];
  stand: ShopUebertragungStand;
}

export const ShopUebertragungStarten = z.object({
  /** Kollektionen und Metafeld-Definitionen sofort abgleichen statt stündlich */
  kollektionen: z.boolean().default(false),
});
